import { api } from './api'
import {
  Case,
  CaseCreateRequest,
  CaseUpdateRequest,
  CaseFilter,
  CaseListResponse,
  CaseStats
} from '../types/case'
import { API_ENDPOINTS } from '../constants/api'

export const caseService = {
  // List cases with optional filters
  listCases: async (filters?: CaseFilter): Promise<CaseListResponse> => {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString())
        }
      })
    }
    const query = params.toString() ? `?${params.toString()}` : ''
    return api.get<CaseListResponse>(`${API_ENDPOINTS.CASES.BASE}${query}`)
  },

  // Get a single case by ID
  getCase: async (id: number): Promise<Case> => {
    return api.get<Case>(API_ENDPOINTS.CASES.byId(id))
  },

  // Create a new case
  createCase: async (data: CaseCreateRequest): Promise<Case> => {
    return api.post<Case>(API_ENDPOINTS.CASES.BASE, data)
  },

  // Update an existing case
  updateCase: async (id: number, data: CaseUpdateRequest): Promise<Case> => {
    return api.put<Case>(API_ENDPOINTS.CASES.byId(id), data)
  },

  // Delete a case (soft delete)
  deleteCase: async (id: number): Promise<void> => {
    return api.delete(API_ENDPOINTS.CASES.byId(id))
  },

  // Restore a soft-deleted case
  restoreCase: async (id: number): Promise<Case> => {
    return api.post<Case>(API_ENDPOINTS.CASES.restore(id))
  },

  // Get case statistics
  getStats: async (): Promise<CaseStats> => {
    return api.get<CaseStats>(API_ENDPOINTS.CASES.STATS)
  }
}